import React, { useState } from "react";
import { FormControlLabel, Switch, LoadingButton, SaveIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultLoadingButton = () => {
  const [loading, setLoading] = useState(true);
  function handleClick() {
    setLoading(true);
  }

  return (
    <>
      <PreviewAndEditor
        height={"200px"}
        language="js"
        title={"Contained Loading button"}
        value={
          'import React, { useState } from "react";\n' +
          'import { FormControlLabel, Switch } from "@mui/material";\n' +
          'import LoadingButton from "@mui/lab/LoadingButton";\n' +
          'import SaveIcon from "@mui/icons-material/Save";\n\n\n' +
          "const [loading, setLoading] = useState(true);\n" +
          "  function handleClick() {\n" +
          "    setLoading(true);\n" +
          "  }\n\n\n" +
          "<FormControlLabel\n" +
          "            sx={{\n" +
          "              display: 'block'\n" +
          "            }}\n" +
          "            control={\n" +
          "              <Switch\n" +
          "                checked={loading}\n" +
          "                onChange={() => setLoading(!loading)}\n" +
          '                name="loading"\n' +
          '                color="primary"\n' +
          "              />\n" +
          "            }\n" +
          '            label="Loading"\n' +
          "          />\n" +
          "          <LoadingButton\n" +
          "            onClick={handleClick}\n" +
          "            loading={loading}\n" +
          '            loadingPosition="start"\n' +
          "            startIcon={<SaveIcon />}\n" +
          "          >\n" +
          "            <span>Save</span>\n" +
          "          </LoadingButton>"
        }
      >
        <FormControlLabel
          sx={{
            display: "block",
          }}
          control={
            <Switch
              checked={loading}
              onChange={() => setLoading(!loading)}
              name="loading"
              color="primary"
            />
          }
          label="Loading"
        />
        <LoadingButton
          onClick={handleClick}
          loading={loading}
          loadingPosition="start"
          startIcon={<SaveIcon />}
        >
          <span>Save</span>
        </LoadingButton>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultLoadingButton;
